import React from 'react'
import Layout from "../components/layout"
import { Link } from "gatsby"
import Footer from '../components/footer'
import BgImage from '../images/bg/solutions-page-banner.jpg'
import SocialIconsFooter from '../components/social-icons-footer'

const SoftwareEngineering = () => {
    return (
        <Layout pageTitle="PragICTS | Software Engineering" og_desc="">
            <div id="wrapper" className="single-page-wrap">
                <div className="content" style={{ textAlign: 'left' }}>
                    <div className="single-page-decor"></div>

                    <div className="single-page-fixed-row">
                        <div className="scroll-down-wrap">
                            <div className="mousey"><div className="scroller"></div></div>
                            <span>Scroll Down</span>
                        </div>
                        <Link to="/" className="single-page-fixed-row-link"><i className="fal fa-arrow-left"></i> <span>Back to home</span></Link>
                    </div>

                    {/* Page Header */}
                    <section className="parallax-section dark-bg sec-half parallax-sec-half-right" data-scrollax-parent="true">
                        <div className="bg par-elem" data-bg={BgImage} data-scrollax="properties: { translateY: '30%' }" style={{ backgroundImage: `url(${BgImage})` }}></div>
                        <div className="overlay"></div>
                        <div className="pattern-bg"></div>
                        <div className="container">
                            <div className="section-title" style={{ textAlign: 'left' }}>
                                <h2>SOFTWARE <br /><span> ENGINEERING</span></h2>
                         
                            </div>
                            <a href="#pragicts-docs-section" className="custom-scroll-link hero-start-link"><span>Let's Start</span> <i className="fal fa-long-arrow-down"></i></a>
                        </div>
                    </section>

                    {/* New Section: Resource Hub */}
                    <section id="pragicts-docs-section" className="pragicts-docs-wrapper" data-scrollax-parent="true">
    <div className="container">
        <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
            <span>//</span>SOFTWARE ENGINEERING
        </div>

        <ul className="pragicts-docs-menu">
            <li>
        <div class="doc-text">
          <i class="fal pragicts-software-icon"></i>
          <h4>Software Engineering</h4>
          <ul>
            <li><i class="fas pragicts-doc"></i><a href="https://standards.pragicts.com/software-development/software-development-phases/" target="_blank">Standard software development process/phases of PragICTS</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/website-support-scope/" target="_blank">Standard website support scope</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/website-minimum-delivery-scope/" target="_blank">Standard website minimum delivery scope</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/website-pre-release-check-list/" target="_blank">Website pre-release checklist</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/why-online-presence/" target="_blank">Why online/digital presence?</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/wordpress/" target="_blank">WordPress-based website?</a></li>
            <li><i class="fas pragicts-doc"></i><a href="https://websites.softwaredevelopment.pragicts.com/content-capture-questionnaire/" target="_blank">Content capture questionnaire</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/shorts/joNRzNW1j7E" target="_blank">Dos and Don'ts in Software Engineering</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=_DXJVKPR3MQ" target="_blank">What does it take for software to succeed</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=vyJ1LgPnjJc" target="_blank">Open Source or Closed Source</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=JJGK3F2_GWo" target="_blank">Software Engineering In A Disruptive Context</a></li>
            <li><i class="fas pragicts-video"></i> <a href="https://www.youtube.com/watch?v=n9DZ_pYtjAo" target="_blank">IT, What It Takes To Capitalize</a></li>
          </ul>
        </div>
      </li>
        </ul>
    </div>

    {/* Decorative lines */}
    <div className="sec-lines"></div>
</section>



                    <SocialIconsFooter />
                </div>
                <Footer />
            </div>
        </Layout>
    )
}

export default SoftwareEngineering;
